"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _qs = _interopRequireDefault(require("qs"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function getQueryStringValue(param, defaultValue) {
  var value;
  if (window && (0, _get.default)(window, 'location.search')) {
    var query = _qs.default.parse(((0, _get.default)(window, 'location.search') || '').replace('?', '')) || {};
    value = query[param];
  }
  return value || defaultValue;
}
var _default = exports.default = getQueryStringValue;